module.exports = __webpack_public_path__ + "img/WildPinataCC_DG.48b12361.jpg";